import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { readerVoices, siteInfo } from "@/mocks/site";

export default function VoicesSection() {
  return (
    <section className="w-full" aria-label="读者口碑">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="READERS"
          title="读者怎么说"
          description="我们更在意档案经不经得起回看。下面是一些长期读者的真实反馈，也是我们继续整理的底气。"
          actionLabel="了解我们的内容原则"
          actionTo="/about"
        />
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3 md:mt-10">
          {readerVoices.slice(0, 3).map((voice) => (
            <figure
              key={voice.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {voice.text}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-900">
                  {voice.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{voice.name}</span>
                  <span className="block text-xs text-foreground-500">{voice.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-lg bg-secondary-100 p-5 md:flex-row md:items-center md:p-6">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-shield-check-line text-lg" />
            </span>
            <div>
              <h3 className="font-heading text-base font-bold text-secondary-900">克制，是这里唯一的原则</h3>
              <p className="mt-1 max-w-2xl text-sm leading-relaxed text-secondary-800">
                {siteInfo.name}只整理公开信息，统一采用匿名化叙述，不做未经核实的结论，也不把推测写成事实。
              </p>
            </div>
          </div>
          <Link
            to="/about"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
          >
            查看完整说明
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}